export default __webpack_public_path__ + "static/media/prune.070439b5.webp";